import React from "react";
import { motion } from "framer-motion";
import { FaHome } from "react-icons/fa";
import '../../../css/builder.css';
import b1 from '../../../assets/builder_logos/section/01.webp';
import b2 from '../../../assets/builder_logos/section/02.webp';
import b3 from '../../../assets/builder_logos/section/03.webp';
import b4 from '../../../assets/builder_logos/section/04.webp';
import b5 from '../../../assets/builder_logos/section/05.webp';
import b6 from '../../../assets/builder_logos/section/06.webp';
import b7 from '../../../assets/builder_logos/section/07.webp';
import b8 from '../../../assets/builder_logos/section/08.webp';
import b9 from '../../../assets/builder_logos/section/09.webp';
import b10 from '../../../assets/builder_logos/section/10.webp';
import b11 from '../../../assets/builder_logos/section/11.webp';
import b12 from '../../../assets/builder_logos/section/12.webp';
import b13 from '../../../assets/builder_logos/section/13.webp';
import b14 from '../../../assets/builder_logos/section/14.webp';
import b15 from '../../../assets/builder_logos/section/15.webp';
import b16 from '../../../assets/builder_logos/section/16.webp';
import b17 from '../../../assets/builder_logos/section/17.webp';
import b18 from '../../../assets/builder_logos/section/18.webp';
import b19 from '../../../assets/builder_logos/section/19.webp';
import b20 from '../../../assets/builder_logos/section/20.webp';
import b21 from '../../../assets/builder_logos/section/21.webp';
import b22 from '../../../assets/builder_logos/section/22.webp';
import b23 from '../../../assets/builder_logos/section/23.webp';
import b24 from '../../../assets/builder_logos/section/24.webp';
import b25 from '../../../assets/builder_logos/section/25.webp';
import b26 from '../../../assets/builder_logos/section/26.webp';
import b27 from '../../../assets/builder_logos/section/27.webp';
import b28 from '../../../assets/builder_logos/section/28.webp';
import b29 from '../../../assets/builder_logos/section/29.webp';
import b30 from '../../../assets/builder_logos/section/30.webp';
import b31 from '../../../assets/builder_logos/section/31.webp';
import b32 from '../../../assets/builder_logos/section/32.webp';
import b33 from '../../../assets/builder_logos/section/33.webp';
import b34 from '../../../assets/builder_logos/section/34.webp';
import b35 from '../../../assets/builder_logos/section/35.webp';
import b36 from '../../../assets/builder_logos/section/36.webp';
import b37 from '../../../assets/builder_logos/section/37.webp';
import b38 from '../../../assets/builder_logos/section/38.webp';
import b39 from '../../../assets/builder_logos/section/39.webp';
import b40 from '../../../assets/builder_logos/section/40.webp';
import b41 from '../../../assets/builder_logos/section/41.webp';
import b42 from '../../../assets/builder_logos/section/42.webp';
import b43 from '../../../assets/builder_logos/section/43.webp';
import b44 from '../../../assets/builder_logos/section/44.webp';
import b45 from '../../../assets/builder_logos/section/45.webp';
import b46 from '../../../assets/builder_logos/section/46.webp';
import b47 from '../../../assets/builder_logos/section/47.webp';
import b48 from '../../../assets/builder_logos/section/48.webp';
import b49 from '../../../assets/builder_logos/section/49.webp';
import b50 from '../../../assets/builder_logos/section/50.webp';
import b51 from '../../../assets/builder_logos/section/51.webp';
import b52 from '../../../assets/builder_logos/section/52.webp';
import b53 from '../../../assets/builder_logos/section/53.webp';
import b54 from '../../../assets/builder_logos/section/54.webp';
import b56 from '../../../assets/builder_logos/section/56.webp';
import b57 from '../../../assets/builder_logos/section/57.webp';
import b58 from '../../../assets/builder_logos/section/58.webp';
import b59 from '../../../assets/builder_logos/section/59.webp';
import b60 from '../../../assets/builder_logos/section/60.webp';
import b61 from '../../../assets/builder_logos/section/61.webp';
import b62 from '../../../assets/builder_logos/section/62.webp';
import b63 from '../../../assets/builder_logos/section/63.webp';
import b64 from '../../../assets/builder_logos/section/64.webp';
import b65 from '../../../assets/builder_logos/section/65.webp';
import b67 from '../../../assets/builder_logos/section/67.webp';
import b68 from '../../../assets/builder_logos/section/68.webp';
import b69 from '../../../assets/builder_logos/section/69.webp';
import b70 from '../../../assets/builder_logos/section/70.webp';
import b71 from '../../../assets/builder_logos/section/71.webp';
import b72 from '../../../assets/builder_logos/section/72.webp';
import b73 from '../../../assets/builder_logos/section/73.webp';
import b74 from '../../../assets/builder_logos/section/74.webp';
import b75 from '../../../assets/builder_logos/section/75.webp';
import b76 from '../../../assets/builder_logos/section/76.webp';
import b77 from '../../../assets/builder_logos/section/77.webp';
import b78 from '../../../assets/builder_logos/section/78.webp';
import b79 from '../../../assets/builder_logos/section/79.webp';
import b80 from '../../../assets/builder_logos/section/80.webp';
import b81 from '../../../assets/builder_logos/section/81.webp';
import b82 from '../../../assets/builder_logos/section/82.webp';
import b83 from '../../../assets/builder_logos/section/83.webp';
import b84 from '../../../assets/builder_logos/section/84.webp';
import b85 from '../../../assets/builder_logos/section/85.webp';
import b86 from '../../../assets/builder_logos/section/86.webp';
import b87 from '../../../assets/builder_logos/section/87.webp';
import b88 from '../../../assets/builder_logos/section/88.webp';
import b89 from '../../../assets/builder_logos/section/89.webp';
import b90 from '../../../assets/builder_logos/section/90.webp';
import b91 from '../../../assets/builder_logos/section/91.webp';
import b92 from '../../../assets/builder_logos/section/92.webp';
import b93 from '../../../assets/builder_logos/section/93.webp';
import b94 from '../../../assets/builder_logos/section/94.webp';
import b95 from '../../../assets/builder_logos/section/95.webp';
import b96 from '../../../assets/builder_logos/section/96.webp';
import b97 from '../../../assets/builder_logos/section/97.webp';
import b98 from '../../../assets/builder_logos/section/98.webp';
import b99 from '../../../assets/builder_logos/section/99.webp';
import b100 from '../../../assets/builder_logos/section/100.webp';
import b101 from '../../../assets/builder_logos/section/101.webp';
import b102 from '../../../assets/builder_logos/section/102.webp';
import b103 from '../../../assets/builder_logos/section/103.webp';
import b55 from '../../../assets/builder_logos/section/55.webp';
import b66 from '../../../assets/builder_logos/section/66.webp';



import { Navbar } from "../Navbar";

const builderLogos = [
    b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22,
    b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43,
    b44, b45,b46, b47, b48, b49, b50, b51, b52, b53, b54, b55, b56, b57, b58, b60, b59, b61, b62, b63, b64, b65, b66, b67,
    b68, b69, b70, b71, b72, b73, b74, b75, b76, b77, b78, b79, b80, b81, b82, b83, b84, b85, b86, b87, b88, b89,
    b90, b91, b92, b93, b94, b95, b96, b97, b98, b99, b100, b101, b102, b103
];

export const BuilderSection = () => {
    return (
        <div>
            <Navbar/><div className="margin"></div>
        <div className="builders-section">
            <div className="topic1">
          <h3 className="topic-title">
                        <span className="diamond"></span>
                List of Top Builders and Developers in Chennai
            <span className="diamond"></span></h3>
            <p className="section-description">
                Are you looking for a new home or office? If yes, then do not worry.
                24k Realtors has listed Best Developers in Chennai that can help
                you find the best property for sale. 24k Realtors has a list of residential,
                commercial, and investment plots for sale in Chennai.
            </p>
            <div className="separator" />

            <div className="logo-grid">
                {builderLogos.map((logo, index) => (
                    <motion.div
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        key={index}
                    >
                        <div className="builder-card">
                            <div className="card-content1">
                                <img
                                    src={logo}
                                    alt={`Builder Logo ${index}`}
                                    className="logo-img"
                                />
                            </div>
                        </div>

                    </motion.div>
                ))}
            </div>

            <div className="stats-grid">
                <div className="stat-box">
                    <h3 className="stat-number">1650+</h3>
                    <p className="stat-label">Properties Listed</p>
                </div>
                <div className="stat-box">
                    <h3 className="stat-number">100+</h3>
                    <p className="stat-label">Locations Covered</p>
                </div>
                <div className="stat-box">
                    <h3 className="stat-number">63+</h3>
                    <p className="stat-label">Expert Agents</p>
                </div>
                <div className="stat-box">
                    <h3 className="stat-number">2500+</h3>
                    <p className="stat-label">Properties Sold</p>
                </div>
            </div>
            </div>
        </div>
        </div>
    )
}
